// An anonymous, random ID for this browser (2026-10-30). The drug pages send it
// with every price lookup, and Flow keeps it on the lookup's activity row (the
// `uuid` column), so the employer report's Drug Search Queries savings can count
// one person's lookups as one: before it, an anonymous lookup was only its IP
// address, which merges a whole office and splits one person across their phone
// and laptop (flow/crm/drug_savings.py). It identifies a browser, never a person,
// and is never sent to Oracle.

export const VISITOR_ID_KEY = 'dc_visitor_id'

const VALID = /^[A-Za-z0-9-]{8,64}$/

// The ID for this page load when the browser keeps nothing (private mode,
// blocked site data): still one visitor across the page's lookups.
let pageId = null

const randomId = () => {
    try {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID()
        }
    } catch (e) {}
    return `v-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
}

const browserStorage = () => {
    try {
        return window.localStorage
    } catch (e) {
        return null
    }
}

// null on the server, where there is no browser to name
export const getVisitorId = ({ storage } = {}) => {
    if (typeof window === 'undefined') {
        return null
    }
    const store = storage === undefined ? browserStorage() : storage
    try {
        const kept = store && store.getItem(VISITOR_ID_KEY)
        if (kept && VALID.test(kept)) {
            return kept
        }
    } catch (e) {}
    const id = pageId || randomId()
    pageId = id
    try {
        if (store) {
            store.setItem(VISITOR_ID_KEY, id)
        }
    } catch (e) {}
    return id
}

// for specs
export const resetPageVisitorId = () => {
    pageId = null
}
